///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/client-type.collection.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
module Meevo.Components.Controls.SmartMover {
    import Dictionary = _.Dictionary;
    import EmployeeCategory = Model.EmployeeCategory;
    export class AlertsManagerEmployeeConfigurationTemplate extends DataTemplateBase implements IDataTemplate {
        private readonly _employees: CollectionOptimizedApi<Model.Variant>;
        private readonly _employeesCategories: CollectionOptimizedApi<EmployeeCategory>;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection() {
            return this._employeesCategories;
        }

        get leafCollection() {
            return this._employees;
        }

        get totalSelectedCount(): number {
            return this._employees.value.length;
        }

        constructor(model: Dictionary<any>, properties: string[], private options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this._employees = new CollectionOptimizedApi(this.model[properties[0]], [], {
                url: 'Employee',
                smartMoverHidden: () => this.smartMoverHidden,
                criteria: {
                    ...options.criteria,
                    showTerminated: true,
                    view: Model.EmployeeSearchView.AllEmployeesWithCategories,
                }
            }, options.$scope);

            this._employeesCategories = new CollectionOptimizedApi(this.model[properties[1]], [], {
                CategoryModel: VirtualRepeatCategory,
                url: 'EmployeeCategory',
                smartMoverHidden: () => this.smartMoverHidden,
            }, options.$scope);

            this._employees.setParentCollection(this._employeesCategories, CoreEmployeeToCategoryStrategy);

            this.filters = [
                new ActiveInactiveFilter({ hideInactiveLabel: 'LABEL_HIDE_INACTIVE_EMPLOYEES' }, this)
            ];

            this._employees.addFilters(...this.filters as IInteractiveFilter[]);

            this.title = 'LABEL_ALL_EMPLOYEES';
            this.allSelectedLabel = 'LABEL_ALL_EMPLOYEES_UPPER';
            this.totalSelectedMessage = 'LABEL_TOTAL_EMPLOYEES_SELECTED';

            if (options.required) {
                this.validation.push(new RequiredValidation(this._employees, 'LABEL_EMPLOYEE_REQUIRED'));
            }
        }

        setWatchers(scope: angular.IScope) {
            this._employeesCategories.setWatchers(scope);
            this.collection.onModelValueChanged();
            super.setWatchers(scope);
        }
    }
}